// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"6bfb1725","1409":"eeb33f95","1590":"261d6918","3016":"c2659036","3922":"261d6918","9441":"7db29fc9"}[chunkId] + ".chunk.css";
};